import script from "./PerfectCompanionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfectCompanionModal.vue?vue&type=script&setup=true&lang=js"

import "./PerfectCompanionModal.vue?vue&type=style&index=0&id=e1f1f310&lang=scss&scoped=true"
import "./PerfectCompanionModal.vue?vue&type=style&index=1&id=e1f1f310&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1f1f310"]])

export default __exports__